<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="6" offset-md="3" class="white elevation-4">
        <h1 class="text-center headline mb-6">Sign Up for LifeWith™</h1>
        <v-form>
          <v-text-field
            type="text"
            v-model="firstName"
            label="First Name"
            required
          ></v-text-field>
          <v-text-field
            type="text"
            v-model="lastName"
            label="Last Name"
            required
          ></v-text-field>
          <v-text-field
            type="email"
            v-model="email"
            label="E-mail"
            required
          ></v-text-field>
          <v-text-field
            type="password"
            v-model="password"
            label="Password"
            required
          ></v-text-field>
          <p class="body text-center">
            Already have an account?
            <router-link to="login">Log In</router-link>
          </p>
          <p class="body text-center">
            By clicking Register, you agree to our
            <router-link to="terms">Terms of Use</router-link>
          </p>
          <v-btn block rounded dark color="orange" class="mt-6" @click="submit">
            <span v-if="!loading">Register</span>
            <v-progress-circular
              indeterminate
              color="white"
              v-if="loading"
            ></v-progress-circular>
          </v-btn>
        </v-form>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar.show">
      {{ snackbar.text }}
      <v-btn color="pink" text @click="snackbar.show = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "Register",
  data() {
    return {
      email: null,
      firstName: null,
      lastName: null,
      loading: false,
      password: null,
      snackbar: {
        show: false,
        text: "",
      },
    };
  },
  methods: {
    ...mapActions({
      register: "users/register",
    }),
    async submit() {
      if (!this.firstName || !this.lastName || !this.email || !this.password) {
        this.snackbar = {
          show: true,
          text: "Please complete all fields",
        };
        return;
      }

      this.loading = true;

      try {
        await this.register({
          email: this.email,
          firstName: this.firstName,
          lastName: this.lastName,
          password: this.password,
        });
        window.location = "/profiles";
      } catch (err) {
        this.snackbar = {
          show: true,
          text: err.message,
        };
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.row {
  padding-top: 10%;
}
</style>
